import { render, staticRenderFns } from "./Desconectar.vue?vue&type=template&id=1c1e92d2&scoped=true"
import script from "./Desconectar.vue?vue&type=script&lang=js"
export * from "./Desconectar.vue?vue&type=script&lang=js"
import style0 from "./Desconectar.vue?vue&type=style&index=0&id=1c1e92d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e92d2",
  null
  
)

export default component.exports